import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { fetch } from '../../actions';
import { Select, Spin } from 'antd';
import Mensagens from '../Mensagens';
import culture from '../../Utils/Culture';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import handleTabIndex from '../../Utils/HandleTabIndex';
import { LoadingContainerPadrao } from '../Base';

const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const SelectPesqProduto = forwardRef(({ onChange, onOk, modelo, showEdit, showAdd, title, noMargin, maxTagTextLength, tipo, ...props }, ref) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [txt, setTxt] = useState(null);
  const { qtd, txtPesquisa } = useMemo(() => formatTxt(txt), [txt]);
  const [estoque, setEstoque] = useState([]);
  const [loadingEstoque, setLoadingEstoque] = useState(false);

  useEffect(() => {

    function keyDown(e) {
      if (e.key === "F2" && tipo == "produto") {
        const ids = data.map(x => x.id);

        if (!loadingEstoque && ids.length && (!estoque || !estoque.length)) {
          setLoadingEstoque(true);

          props.fetch().post("estoque/prodest/multiplo", ids).then(res => {
            setEstoque(res.data);
            setLoadingEstoque(false);
          }).catch(() => {
            Mensagens.showErro("Ocorreu um erro ao obter o estoque");
            setLoadingEstoque(false);
          });
        }

      }
    }

    document.addEventListener("keydown", keyDown);

    return () => document.removeEventListener("keydown", keyDown);
  }, [data, loadingEstoque]);

  useEffect(() => {
    if (!txt?.length && !!data?.length)
      setData([]);

  }, [data]);

  function listar(enterClicked) {

    if (!txtPesquisa?.length)
      return;

    setEstoque([]);
    setLoading(true);

    props.fetch().post(`/${tipo}/getlist`, { txt: txtPesquisa })
      .then(response => {

        if (enterClicked && response.data && response.data?.length === 1) {
          onChangeInternal(response.data);
          setData([]);
        }
        else
          setData(response.data);

        setLoading(false);
      })
      .catch(err => { Mensagens.showErro(err); setLoading(false); });
  }

  function onChangeInternal(newData) {
    const val = data?.find(s => s.id == Number(newData[0].key)) ?? newData[0];
    setTxt(null);
    setData([]);
    onChange(val, qtd > 0 ? qtd : 0);
    proximoTab();
  };

  const proximoTab = () => handleTabIndex(props.tabIndex, props.nextTab);

  return <Select
    ref={ref}
    suffixIcon={<SearchOutlined />}
    mode="multiple"
    labelInValue
    data-cy="pesq-produto"
    id="pesq-produto"
    placeholder={`Pesquisar ${tipo}`}
    maxTagTextLength={maxTagTextLength ? maxTagTextLength : 35}
    notFoundContent={loading ? <Spin indicator={antIcon} size="small" /> : null}
    filterOption={false}
    defaultActiveFirstOption={false}
    value={[]}
    {...props}
    searchValue={txt}
    onSearch={setTxt}
    onChange={onChangeInternal}
    onBlur={e => {
      setData([]);
      setEstoque([]);
      setTxt(null);
      if (!!props?.onBlur)
        props?.onBlur(e);
    }}
    onDropdownVisibleChange={() => setTxt(null)}
    onInputKeyDown={e => {
      if (e.key == "Enter")
        listar(true);
    }}
    style={{ width: "100%", ...props.style }}
    dropdownMenuStyle={{ maxHeight: "50vh", ...props.dropdownMenuStyle }}
    dropdownStyle={{ zIndex: props.zIndex }}
    dropdownRender={menu => (
      <LoadingContainerPadrao loading={loadingEstoque}>
        <div style={{ display: 'flex', padding: 10, fontWeight: 'bold' }}>
          <div style={{ flex: 1 }}>{tipo == "produto" ? "Produto" : "Serviço"}</div>
          <div style={{ minWidth: 90, textAlign: 'center' }}>Preço</div>
          {tipo == "produto" && <div style={{ minWidth: 90, textAlign: 'center' }}>Estoque</div>}
        </div>
        <div style={{ minHeight: 1, backgroundColor: '#ddd' }}></div>
        {menu}
      </LoadingContainerPadrao>
    )}
    loading={loading}
  >
    {data.map((d, inx) => (
      <Option key={d.id} data-cy={`pesq-produto-item-${inx}`}>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>{d.codigo} {d.descricao}</div>
          <div style={{ minWidth: 90, textAlign: 'center' }}>R$ {culture.format(d.preco)}</div>
          {tipo == "produto" && <div style={{ minWidth: 90, textAlign: 'center' }}>{estoque.find(s => s.id == d.id) ? culture.format(estoque.find(s => s.id == d.id).qtd) : (estoque.length ? "0,00" : "-")}</div>}
        </div>
      </Option>
    ))}
  </Select>;
});

export default connect(null, { fetch }, null, { forwardRef: true })(SelectPesqProduto);

function formatTxt(str) {
  if (!str)
    return { qtd: null, txtPesquisa: null };

  let qtd = 1;
  let laTxt = str.split('*');
  let txtPesquisa = str;

  if (laTxt.length > 1) {
    qtd = parseFloat(laTxt[0]?.replace(',', '.'));
    txtPesquisa = laTxt[1].trim();
  }

  return { qtd, txtPesquisa };
}